module.exports = __webpack_public_path__ + "static/media/Salvador Gala.e77ac148.png";